import React, {useState} from 'react';
import styled from 'styled-components';
import FormTextField from "../ui/components/form-controls/form-text-field";
import {_searchAddress} from "../store/addresses/service"
import Button from "../ui/components/buttons/button";

const DivQuoteAddressDropdownMenu = styled.div`
    background-color: #fff;
    position: absolute;
    width: 100%;
    min-height: 104px;
    z-index: 1;
    max-height: 200px;
    overflow-x: hidden;
    overflow-y: scroll;
    font-family: Inter, Verdana, Arial, sans-serif;
    box-shadow: 
        0px 5px 5px -3px rgba(0,0,0,0.2), 
        0px 8px 10px 1px rgba(0,0,0,0.14), 
        0px 3px 14px 2px rgba(0,0,0,0.12);
`

const UlQuoteAddressDropdownMenu = styled.ul`
    background-color: #f1f2f4;
    font-size: 16px;
    list-style-type: none;
    top: 5px;
    margin: 0px;
    text-align: left;
    padding: 0px;
    color: #0a1f44;
`

const LiQuoteAddressDropdownMenu = styled.li`
    padding: 0px 0px 0px 13px;
    margin: 0px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    line-height: 40.0px;
    &:hover {
        background-color: #cccccc;
    }
`

const AddressDropdown = React.forwardRef((
    {
        label,
        value,
        onChange,
        onMatched,
        onSearch,
        onClick,
        onReset,
        disabled,
        showDetail,
        ...rest
    },
    ref
    ) => {
        const [selectedValue, setSelectedValue] = useState(value || '');
        const [addressList, setAddressList] = useState ( [] );
        const [toggleDropdown, setToggleDropdown] = useState ( false );

        const [validPostalCode, setValidPostalCode] = useState ( false );
        let addressDropdownMenu = null;

    const handleChange = (event) => {
        let value = event.target.value;

        setSelectedValue(value);
        if(!!onChange){
            onChange(value,setSelectedValue);
        }
    }

    const handleSearch = (event) =>{
        let value = selectedValue
        if(value?.trim().length > 5){
            _searchAddress(value).then(data => {
                setAddressList(data);
                if(data.length===2){
                    if(!!onMatched){
                        onMatched(data[0],setSelectedValue);
                    }
                    setValidPostalCode(true)
                }
                if(!!showDetail){
                    showDetail(true)
                }

            });
        }
    }

    const handleClick = (event, item) => {
        event.preventDefault();
        setToggleDropdown(false);

        if(!!onChange){
            onChange(item);
        }
        if(!!onClick){
            // If parent wants to handle click event
            onClick(item, setSelectedValue);
        }
    }

        if(addressList && addressList.length > 1 && toggleDropdown){
            addressDropdownMenu = (
                <DivQuoteAddressDropdownMenu>
                    <UlQuoteAddressDropdownMenu>
                        {addressList.map(item => {
                            return (
                                <LiQuoteAddressDropdownMenu 
                                    key={item.postCode}  
                                    onClick={(event) => {handleClick(event, item)}}>
                                    {item.streetName}
                                </LiQuoteAddressDropdownMenu>
                                )
                            })
                        }
                    </UlQuoteAddressDropdownMenu>
                </DivQuoteAddressDropdownMenu>
            );
        }

        return (
            <React.Fragment>
                <FormTextField
                    {...rest}
                    ref={ref} 
                    label={label}
                    className={`AddressDropdownField `}
                    isSuccess={validPostalCode}
                    disabled={disabled||validPostalCode}
                    value={selectedValue || value}
                    helperText={' '}
                    minLength={6}
                    onClick={(event) => {setToggleDropdown(false)}} 
                    onChange={handleChange}>
                </FormTextField>
                { addressDropdownMenu }
                <div className={"AddressDropdownControl"}>
                    <Button color={"secondary"} onClick={() => {
                        if(!!onReset)
                            onReset(setSelectedValue)
                        setValidPostalCode(false)
                    }}
                    >Clear</Button>
                    <Button
                        disabled={validPostalCode}
                        onClick={handleSearch}
                    >Search</Button>
                </div>
            </React.Fragment>
        );
    });

export default AddressDropdown
